import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../api/queryKeys';
import { kotService } from '../api/services/kotService';
import type { KotDto, KotsQuery } from '../api/types/dine.types';

/** GET /kots — live tickets by default, polled every 8 s while visible. */
export function useKots(params: KotsQuery = {}, enabled = true) {
  return useQuery<KotDto[], Error>({
    queryKey: queryKeys.kots(params),
    queryFn: () => kotService.list(params),
    refetchInterval: 8_000,
    refetchIntervalInBackground: false,
    staleTime: 4_000,
    enabled,
  });
}
